import React from 'react';
import './UploadProgress.css';

interface UploadProgressProps {
  progress: number;
}

const UploadProgress: React.FC<UploadProgressProps> = ({ progress }) => {
  return (
    <div className="upload-progress">
      <div className="progress-header">
        <h3>Upload Progress</h3>
        <span className="progress-percentage">{progress}%</span>
      </div>
      
      <div className="progress-bar-container">
        <div 
          className="progress-bar"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      
      <div className="progress-status">
        {progress < 100 ? 'Uploading to S3...' : 'Upload Complete!'}
      </div>
    </div>
  );
};

export default UploadProgress; 